import React from 'react';
import { Button } from 'react-bootstrap';

const SideMenuBtn = ({ title, icon: Icon, handleClick, ...props }) => (
  <Button variant="flat" className="text-start my-1" onClick={handleClick} {...props}>
    <span className="pe-3">
      <Icon />
    </span>
    {title}
  </Button>
);

export default SideMenuBtn;
